import { Request } from '@moeco-platform/clients'

const requestInstance = new Request({
  baseUrl: process.env.VUE_APP_API_URL,
  apiKey: null
});

export default requestInstance;
